import { Link } from 'react-router-dom';
import beemiLogo from '../../assets/beemi-logo.png';
import { LINE_GRADIENT } from '../../constants/gradients';

interface LogoProps {
  to?: string;
  size?: 'sm' | 'md' | 'lg';
  showIcon?: boolean;
  className?: string;
}

export default function Logo({ 
  to = '/', 
  size = 'md',
  showIcon = true,
  className = ''
}: LogoProps) {
  const sizeClasses = {
    sm: {
      icon: 'w-6 h-6',
      beemiText: 'text-xl',
      playText: 'text-base',
    },
    md: {
      icon: 'w-8 h-8',
      beemiText: 'text-3xl',
      playText: 'text-2xl',
    },
    lg: {
      icon: 'w-12 h-12',
      beemiText: 'text-4xl',
      playText: 'text-3xl',
    },
  };

  const sizes = sizeClasses[size];

  const content = (
    <>
      {showIcon && (
        <img 
          src={beemiLogo} 
          alt="Beemi" 
          className={`${sizes.icon} flex-shrink-0 -translate-y-1`} 
        />
      )}
      <span className="whitespace-nowrap inline-flex items-baseline">
        <span className="relative inline-block">
          {/* Solid color layer */}
          <span className={`font-bold lowercase ${sizes.beemiText} text-gray-900 dark:text-dark-text transition-opacity duration-300 group-hover:opacity-0`}>
            Beemi
          </span>
          {/* Gradient layer */}
          <span 
            className={`font-bold lowercase ${sizes.beemiText} absolute inset-0 opacity-0 transition-opacity duration-300 group-hover:opacity-100`}
            style={{
              backgroundImage: LINE_GRADIENT,
              backgroundClip: 'text',
              WebkitBackgroundClip: 'text',
              WebkitTextFillColor: 'transparent',
            }}
          >
            Beemi
          </span>
        </span><span className={`font-light uppercase ${sizes.playText} text-gray-900 dark:text-dark-text transition-colors duration-300 group-hover:text-[#FF00CF]`}>WEB</span>
      </span>
    </>
  );

  return (
    <Link 
      to={to} 
      className={`group flex items-center gap-2 ${className}`}
    >
      {content}
    </Link>
  );
}
